import { useContext } from "react";

import Context from "../../context";
import ConnectBtn from "./ConnectBtn";
import CustomConnectBtn from "./CustomConnectBtn";

// ----------------------------------------------------------------------

type Props = {
	loading?: boolean;
	userConfirmationNeeded?: boolean;
};

export const DConnectButton = ({ loading, userConfirmationNeeded }: Props) => {
	const { customConnectProps } = useContext(Context);

	const hasTheme = !!customConnectProps?.theme;

	return hasTheme ? (
		<CustomConnectBtn loading={loading} userConfirmationNeeded={userConfirmationNeeded} />
	) : (
		<ConnectBtn loading={loading} userConfirmationNeeded={userConfirmationNeeded} />
	);
};

export default DConnectButton;
